module.exports = __webpack_public_path__ + "media/mail/fa-linkedin-477685cd.png";